import { useContext } from 'react';
import { RiCloseLine } from 'react-icons/ri'
import AppContext from '../../../AppContext/AppContext';

import './Modal.css';

function Modal({ modalHeading,  children }) {

    const {hideModalRemoveVideoLink } = useContext(AppContext)

    return (
        <div className={`modal`}>
            <div className="modal_backdrop" onClick={hideModalRemoveVideoLink}></div>
            <div className={`modal_dialog modal_dialog_centered modal_dialog_scrollable`}>
                <div className="modal_content">
                    <button type='button' className='modal_close' onClick={hideModalRemoveVideoLink}><RiCloseLine /></button>
                    {modalHeading &&
                        <h1 className="modal_heading">{modalHeading}</h1>
                    }
                    <div className="modal_body">{children}</div>
                </div>
            </div>
        </div>
    )
}
export default Modal